/**
 * What an event of the staff stream makes stale on the support screens.
 *
 * hg-realtime tells the support desk of a message in a thread, from either
 * side (`support.message_created`). A message written while the stream was
 * away is not sent again (it is of hg-content's stream, not hg-order's), so
 * a `connected` that is a return (`reconnected`) reads the counts, the
 * lists and the open threads afresh too. The first of a page is not: the
 * screens have just read them, and a stream that opened late says `resync`,
 * which reads everything.
 */
import { textOf, type LiveEvent, type Refresh } from "@/shared/live";

import { SUPPORT_KEY, threadKey } from "./queries";

/**
 * A message in a thread: the thread, the list it is in and the counts move.
 * The event carries no words: the screens read them.
 */
export function supportLive(event: LiveEvent, refresh: Refresh): void {
  const returned = event.type === "connected" && event.reconnected === true;
  if (event.type !== "support.message_created" && !returned) return;
  refresh([...SUPPORT_KEY, "threads"]);
  refresh([...SUPPORT_KEY, "counts"]);
  refresh([...SUPPORT_KEY, "of"]);
  if (returned) {
    // Which thread the missed messages are in is not known: every one open.
    refresh([...SUPPORT_KEY, "thread"]);
    return;
  }
  const threadId = textOf(event, "thread_id");
  if (threadId !== null) refresh(threadKey(threadId));
}
